export default __webpack_public_path__ + "static/media/hrp-white-2.210e01e3.svg";